// extracted by mini-css-extract-plugin
export var chevron = "_2f-d";
export var disabled = "_2f-b";
export var error = "_2f-c";
export var hideBorder = "_2f-1";
export var icon = "_2f-e";
export var input = "_2f-0";
export var large = "_2f-f";
export var open = "_2f-9";
export var placeholder = "_2f-a";
export var regular = "_2f-5";
export var singleRowInput = "_2f-2";
export var singleSelectInput = "_2f-3 _2f-0";
export var small = "_2f-4";
export var spinnerContainer = "_2f-i";
export var tag = "_2f-7";
export var tagsContainer = "_2f-8";
export var tagsInput = "_2f-6 _2f-0";
export var xSmall = "_2f-g";
export var xxSmall = "_2f-h";